import React, { useState } from "react";
import { requestWithHeaders } from "../api/requestMethods";

const UpdateCompletionNotesComponent = ({ modalData, toggleModal }) => {
  const [completionNotes, setCompletionNotes] = useState(
    modalData?.completion_notes || ""
  );
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const response = await requestWithHeaders.post(
        `/api/admin/update-completion-notes`,
        {
          id: modalData.id,
          completion_notes: completionNotes ?? "",
        }
      );
      if (response?.data?.status) {
        toggleModal();
      }
    } catch (error) {
      console.log(error);
      alert("Catatan Akhir Pelayanan gagal diupdate!");
    }
    setLoading(false);
  };

  return (
    <div>
      <div className="input-group flex-nowrap">
        <textarea
          className="form-control"
          placeholder="Catatan Akhir Pelayanan"
          maxLength={500}
          aria-label="Catatan Akhir Pelayanan"
          aria-describedby="addon-wrapping"
          value={completionNotes} // Controlled component
          rows={4} // Set height to 4 lines
          style={{ resize: "none" }} // Prevent resizing
          onChange={(e) => setCompletionNotes(e.target.value)} // Handle changes
          disabled={modalData.status !== 3} // Disable textarea if status is not 3
        />
      </div>

      {/* Update Button */}
      <button
        className="btn btn-primary mt-3" // Styling for Bootstrap button
        onClick={handleSubmit} // Call handleSubmit when the button is clicked
        disabled={modalData.status !== 3 || loading} // Disable textarea if status is not 3
      >
        Selesai
      </button>
    </div>
  );
};

export default UpdateCompletionNotesComponent;
